import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Transaction } from 'lib/api/express/transaction/types';

export type TransactionState = {
  transaction: Transaction | null;
  originUrl: string | null;
};

const initialState: TransactionState = {
  transaction: null,
  originUrl: null,
};

const transactionSlice = createSlice({
  name: 'transaction',
  initialState,
  reducers: {
    saveTransaction: (
      state,
      action: PayloadAction<{
        transaction: Transaction;
        originUrl: string;
      }>,
    ) => {
      state.transaction = action.payload.transaction;
      state.originUrl = action.payload.originUrl;
    },
    clearTransaction: (state) => {
      state.transaction = null;
      state.originUrl = null;
    },
  },
});

export const { saveTransaction, clearTransaction } = transactionSlice.actions;
export default transactionSlice.reducer;
